<template>
  <div>
    <div class="row" style="margin-bottom: 20px;">
      <div
        v-for="s in status" :key="s.bank" class="block"
        :class="{'red': notUpToDate(s), 'green': !notUpToDate(s)}"
      >
        <b>{{s.bank}}</b><br>{{(new Date(s.date)).toLocaleDateString()}}
      </div>
    </div>

    <tableFilter
      name="activityFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getLogs"
      v-model="filters"
    />

    <div class="card" v-if="logs !== null && logs.length">
      <table>
        <thead class="table-legend">
          <tr>
            <th style="width:15%">Datum</th>
            <th>IP-adres</th>
            <th style="width:30%">Klant nr. & Gebruikersnaam</th>
            <th style="width:10%">Door admin</th>
            <th style="width:20%">Type</th>
          </tr>
        </thead>
        <tr
          v-for="log in logs"
          :key="log.id"
        >
          <td width="15%">{{(new Date(log.date)).toLocaleString()}}</td>
          <td>{{log.ip}}</td>
          <td style="width:30%">
            {{log.client === null ? '' : `#${log.client}: `}}{{log.username}}<br>
            <span class="grey">{{log.name}}</span>
          </td>
          <td style="width:10%">{{log.become ? 'id:' : ''}} {{log.become}}</td>
          <td style="width:20%">{{log.type}}</td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalLogs"
        :maxPerPage="maxPerPage"
      />
    </div>

    <div v-else-if="logs !== null" class="noresults">
      <span>Geen resultaten</span>
    </div>

    <div v-else class="loader" />
  </div>
</template>

<script>
export default {
  name: 'AdminActivity',
  data() {
    return {
      logs: null,
      totalLogs: 0,
      maxPerPage: 20,
      currentPage: 0,
      status: null,
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'activityGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
          title: 'IP-adres, Gebruiker, Admin',
        },
        {
          name: 'logTypeInput',
          type: 'multiDropdown',
          position: 'topbar',
          cookie: 'activityLogTypeInput',
          filterName: 'type',
          operator: 'in',
          model: '',
          selectedTypes: [],
          attributes: [
            {
              name: 'array',
              value: [
                { value: 0, label: 'Inlog (succesvol)' },
                { value: 1, label: 'Inlog (mislukt)' },
                { value: 2, label: 'Wachtwoord aangepast' },
                { value: 3, label: 'Wachtwoord herstellink aangevraagd door gebruiker' },
                { value: 4, label: 'Wachtwoord herstellink opgestuurd door beheerder' },
                { value: 5, label: 'Download' },
                { value: 6, label: 'Gebruiker aangemaakt' },
                { value: 7, label: 'Delete upload' },
                { value: 8, label: 'Situatie gelijk gebleven' },
                { value: 9, label: 'Email aangepast van' },
                { value: 10, label: 'Bestand geupload' },
                { value: 11, label: '2fa verwijderd' },
                { value: 12, label: '2fa toegevoegd' },
                { value: 13, label: '2fa verwijderd door admin' },
                { value: 14, label: 'Port. toegewezen aan gebruiker' },
                { value: 15, label: 'Port. verwijderd van gebruiker' },
                { value: 16, label: 'Intake gestart' },
                { value: 17, label: 'Intake ingeleverd' },
                { value: 18, label: 'Intake accepted' },
                { value: 19, label: 'Port aan intake koppelen' },
                { value: 20, label: 'Intake verplaatsen naar andere gebruiker' },
                { value: 21, label: 'Intake gestopt' },
                { value: 22, label: 'Intake ondertekend' },
                { value: 23, label: 'Intake permanent verwijderd' },
                { value: 24, label: 'Mandaat geaccepteerd' },
                { value: 25, label: 'Mandaat toegevoegd' },
                { value: 26, label: 'Machtigingsaanvraag afgewezen (door klant)' },
                { value: 27, label: 'Machtiging verwijderd (door adviseur)' },
                { value: 28, label: 'Machtiging ingetrokken (door klant)' },
                { value: 29, label: 'Machtigingsaanvraag verwijderd (door adviseur)' },
                { value: 30, label: 'Gebruikersnaam vergeten' },
                { value: 31, label: 'Intake van geaccepteerd naar ingeleverd' },
                { value: 32, label: 'Adviseur plus koppelt intake' },
                { value: 33, label: 'Intake van ingeleverd naar bezig' },
                { value: 34, label: 'Gebruiker verwijderd door' },
                { value: 35, label: 'Intake snel accepteren' },
                { value: 36, label: 'Actie vereist gestart' },
                { value: 37, label: 'Actie vereist gestopt' },
                { value: 38, label: 'Offer calc' },
                { value: 39, label: 'Gegevens gewijzigd van adviseur' },
                { value: 40, label: 'Adviseur plus herstuurt koppelmail naar' },
              ],
            },
            {
              name: 'displayValue',
              value: true,
            },
            {
              name: 'displayPrefix',
              value: 'Types ',
            },
          ],
        },
        {
          name: 'minDate',
          label: 'Vanaf',
          type: 'date',
          model: '',
          cookie: 'activityMinDateInput',
          filterName: 'date',
          operator: 'eqgt',
          operators: ['eqgt', 'gt'],
          attributes: [
            {
              name: 'max',
              value: this.updateDateLimits('minmax'),
            },
          ],
        },
        {
          name: 'maxDate',
          label: 'Tot',
          type: 'date',
          model: '',
          cookie: 'activityMaxDateInput',
          filterName: 'date',
          operator: 'eqlt',
          operators: ['eqlt', 'lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'ipInput',
          label: 'IP-adres',
          type: 'string',
          cookie: 'activityIpInput',
          model: '',
          filterName: 'ip',
          operator: 'contains',
          operators: ['eq', 'neq', 'startswith', 'endswith', 'contains'],
        },
        {
          name: 'userIdInput',
          label: 'Gebruiker',
          type: 'user',
          cookie: 'activityUserIdInput',
          model: this.$store.state.activityUserId !== null ? this.$store.state.activityUserId : '',
          filterName: 'client',
          operator: 'eq',
          operators: ['eq', 'neq'],
        },
        {
          name: 'adminIdInput',
          label: 'Admin',
          type: 'user',
          cookie: 'activityAdminIdInput',
          model: '',
          filterName: 'become',
          operator: 'eq',
          operators: ['eq', 'neq'],
          roles: [1, 2, 8, 9, 10],
        },
      ],
    };
  },
  created() {
    this.getStatus();
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    updateDateLimits(type) {
      if (type === 'minmax') {
        if (this.maxDateFilter) {
          if (new Date(this.maxDateFilter).getDate() === new Date().getDate()) {
            const newDate = new Date(this.maxDateFilter);
            newDate.setDate(newDate.getDate() - 1);
            return this.formatDate(newDate);
          }

          return this.formatDate(new Date(this.maxDateFilter));
        }
        return this.formatDate(new Date());
      }
      if (type === 'maxmin' && this.minDateFilter) {
        return this.formatDate(new Date(this.minDateFilter));
      }
      if (type === 'maxmax') {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        return this.formatDate(currentDate);
      }
      return '';
    },
    toggleType(type) {
      if (this.selectedTypes.indexOf(type) > -1) {
        this.selectedTypes.splice(this.selectedTypes.indexOf(type), 1);
      } else {
        this.selectedTypes.push(type);
      }
    },
    formatDate(date) {
      return `${date.getFullYear()}-${
        date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1
      }-${
        date.getDate() < 10 ? '0' : ''}${date.getDate()
      }`;
    },
    getLogs(newSearch, filter = '', activeFilters = []) {
      this.logs = null;
      this.activeFilters = activeFilters;

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }

      this.sdk.getAllLogs((response) => {
        if (response.status === 200) {
          this.logs = response.data.results;
          this.totalLogs = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
    getStatus() {
      this.sdk.getStatus((response) => {
        if (response.status === 200) {
          this.status = response.data;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    notUpToDate(bank) {
      const now = new Date();
      const update = new Date(bank.date).toLocaleDateString();
      if (now.toLocaleDateString() !== update && now.getDay() !== 0) {
        if (bank.bank === 'BAL' || bank.bank === 'BNCK') {
          return false;
        }
        if (now.getDay() === 1 && bank.bank !== 'AAB') {
          return false;
        }
        if (
          now.getDay() === 6 && bank.bank !== 'AAB') {
          return false;
        }
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .menubar {
    padding: 2px;
    border-radius: 0;
    input {
      vertical-align: top;
    }
    .type-dropdown {
      vertical-align: top;
      width: auto !important;
      button {
        border-radius: 0;
        margin-left: 2px !important;
      }
    }
    .topbarButton {
      height: 36px;
      display: inline-block;
      align-items: center;
      margin-left: 2px;
      border-radius: 0;
    }
    .dropdown {
      width: 120px;
      margin: 0;
      display: inline-block;
      .dropdown-button {
        margin-left: 3px;
        width: 110px;
        padding: 0px;
      }
      .dropdown-list {
        width: 430px !important;
        right: 0;
        top: 36px;
        li {
          display: flex;
          align-items: center;
          padding-left: 15px;
          position: relative;
          user-select: none;
          .dropdown-checkbox {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            svg {
              font-size: 13px;
            }
          }
          span.logTypeId {
            position: absolute;
            top: 50%;
            right: 15px;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
  .dropdown-button,
  .search-button {
    border-radius: 0;
    float: left;
    margin-right: 2px;
  }
  .checkbox-green {
    color: #59b300;
  }
  table {
    table-layout:fixed;
  }
  .block {
    margin-right:20px;
    float: left;
    background-color: $color-grey-dark;
    padding: 10px;
    border-radius: 2px;
  }
  .searchbar {
    width: 300px;
    float: left;
    max-width: 500px;
  }
  .noresults {
    width: 100%;
    height: auto;
    padding: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 20px;
    }
  }
</style>
